import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Alert
} from "reactstrap";
import i18n from "../../../i18n";
import { delUsersAdminDelete } from "../../../helpers/api_rombo_helper";

const DeleteModal = ({ isOpen, toggle, setDeleteModal, setShowAlertSuccess, clickUser, setClickUser, setTextHeader, setTextBody, setReloadUsers, token, reloadUsers }) => {

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  function onClickSave() {
    let body  = {
      user_ids: [clickUser.id]
    }
    delUsersAdminDelete(token, body)
      .then((response) => {
        setDeleteModal(false)
        setShowAlertSuccess(true)
        setClickUser({})
        setTextHeader(i18n.t("DeletedUsers"))
        setTextBody(i18n.t("SuccessDeletedUsers", { number: 1 }))
        setReloadUsers(!reloadUsers)
      })
      .catch((error) => {
        console.error("Error - delUsersAdminDelete ", error)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
        if(error.code == 500) setErrorAlertMessage(i18n.t("NetworkError"))
        setErrorAlert(true)
      })
  }

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DeleteUser")}</p>
        <p className="cancellation-confirmation">{i18n.t("Confirmation")}</p>
        <div className="modal-separator"></div>
        <ModalBody className="mt-0 pt-0">
          <div id="liveAlertPlaceholder">
            <Alert color="danger" isOpen={errorAlert} toggle={() => {
              setErrorAlert(false)
            }}>
              {errorAlertMessage}
            </Alert>
          </div>
          <Row>
            <p className="cancellation-text">{i18n.t("TextDeleteUser")}</p>
            <p className="cancellation-text">
              {clickUser.full_name} ({clickUser.email})
            </p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-danger"
            type="button"
            onClick={onClickSave}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setDeleteModal: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  clickUser: PropTypes.object,
  token: PropTypes.object,
  setReloadUsers: PropTypes.func,
  setClickUser: PropTypes.func
}

export default DeleteModal;
